<template>
  <div class="img-login">
    <img class="img-logo" src="@/assets/TPM_yourpath.svg" alt="logo tpm">
    <div class="img__bbb">
      <a class="img__bbb__link" href="https://www.bbb.org/us/ca/downey/profile/computer-software-developers/home-media-products-llc-1216-100107486" target="_blank">
        <img class="img__bbb__link__img" src="@/assets/logo_bbb.svg" alt="Accredited business">
      </a>
    </div>
  </div>
</template>
<script>
export default {
   name: 'LoginCarousel',
};
</script>
<style lang="scss" scoped>
.img-login{
  position: relative;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url('~@/assets/img-carousel-3.jpeg');
    border-radius: 3rem;
    @media (min-width: 300px) and (max-width: 719px){
      height: 300px;
    }
    @media (min-width: 720px) and (max-width: 889px){
      height: 400px;
    }
    @media (min-width: 890px) and (max-width: 1401px){
      height: 450px;
   }
   @media all and (min-width: 1402px) {
    height: 524px;
   }
}
.img-logo{
  position: absolute;
  width: 80px;
  top: 0.5em;
  left: 0.5em;
  z-index: 3;
    @media (min-width: 600px) and (max-width: 900px){
      width: 9rem;
    }
    @media all and (min-width: 901px) {
          display: none;
    }
}
.img__bbb{
  z-index: 3;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: end;
  &__link{
    cursor: pointer;
      &__img{
        width: 8rem;
        @media (min-width: 600px) and (max-width: 900px){
          width: 11rem;
        }
        @media all and (min-width: 901px) {
          display: none;
        }
      }
  }
  @media (min-width: 901px) and (max-width: 1920px){
  //TODO
  }
  @media all and (min-width: 1921px){
  // TODO
  }
}
</style>